<template>
    <modal
        name="company-contract-type-modal"
        class="modal--translation modal--hide-on-loading"
        v-cloak height="auto"
        width="500px"
        :scrollable="false"
        :adaptive="true"
        :pivot-y="0.25"
    >
        <div class="modal-header">
            <button @click="closeModal()" type="button" class="close close-modal mr-2"><i
                class="fal fa-fw fa-times"></i></button>

            <h5 class="modal-title mb-0">
                <i class="fa fa-fw fa-cog mr-1"></i>
                {{ trans(isEdit ? 'edit-title' : 'create-title') }}
            </h5>
        </div>

        <div class="modal-body" :class="{'loading': loading }">
            <form action="">
                <div class="form-group">
                    <label for="name">{{ trans('title') }}</label>
                    <input type="text" id="name" class="form-control" v-model="companyContractType.title">
                </div>
                <div class="form-group">
                    <label for="shortcode">{{ trans('shortcode') }}</label>
                    <input type="text" id="shortcode" class="form-control" v-model="companyContractType.shortcode">
                </div>
            </form>
        </div>

        <div class="modal-footer text-center">
            <b-button type="button" variant="primary" @click="submitForm(companyContractType.id)"
                      :class="{'loading disabled': loading }"
            >
                <i class="fa fa-save"></i>
                {{ trans('save') }}
            </b-button>
        </div>
    </modal>
</template>


<script>
import TranslationsUtils from "../../app-components/TranslationsUtils";

export default {
    mixins: [TranslationsUtils],

    props: {
        "baseUrl": {
            type: String
        },
    },

    data: function() {
        return {
            url: this.baseUrl,
            loading: false,
            companyContractType: {},
            isEdit: false,
        };
    },

    methods: {
        open(item, isEdit) {
            this.companyContractType = item;
            this.isEdit = isEdit;
            this.url = this.baseUrl.replace('__id__', item.id);
            this.$modal.show('company-contract-type-modal');
        },

        submitForm(id) {
            this.loading = true;

            let suffixUrl = this.isEdit ? "/" + id : "";

            axios.post(this.url + suffixUrl, {
                name: this.companyContractType.title,
                shortcode: this.companyContractType.shortcode,
                company_id: this.companyContractType.company_id
            })
                .then(() => {
                    this.closeModal();
                    window.location.reload();
                    this.loading = false;
                })
                .catch(() => {
                    this.closeModal();
                    this.$notify({ type: "error", title: "Error!" });
                    this.loading = false;
                });
        },

        closeModal() {
            this.$modal.hide("company-contract-type-modal");
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-header {
    padding: 0;
    margin: 0 0 35px;
    border-bottom: 0;
}

h6.head-title {
    margin-bottom: 20px;
    font-size: 1.1rem;
}

.modal-footer {
    padding: 0;
    margin-top: 18px;
    border: 0;
}

.form-group {
    margin-bottom: 3px;
}

.form-settings {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 4rem;
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/company-contract-type/modals/CompanyContractTypeModal.vue